// Services
import { getPerformanceFleet, PerformanceFleetResponseSchema } from '@services/index';

/**
 * Fetches performance fleet data\.
 *
 * @async
 * @function
 * @returns {Promise<PerformanceFleet>} - A promise that resolves to the fetched performance fleet data.
 */
export const performanceFleetController = async () => {
  const { data } = await getPerformanceFleet();

  return PerformanceFleetResponseSchema.parse(data);
};
